import { TemplateEditor } from "./TemplateEditor";
export default TemplateEditor;
export * from "./TemplateEditor";
